import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import * as moment from 'moment';
import * as Raven from 'raven-js';

import Root from './routers/Root';
import configureStore from 'store/configureStore';
//import piwikTracker from './utils/piwik';
import * as api from './api';
import { isMobile } from 'utils/isMobile';
import * as LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';

const store = configureStore();

export function init() {
  configureSentry();
  configureMoment();
  //configurePiwik();
  configureLogRocket();
  try {
    api.user.updateLanguageByLocale();
  } catch (e) {}

  renderRootElement();
}

async function checkHomeRoot() {
  if (
    !isMobile() &&
    moment().format('YYYY-MM-DD') > moment('2018-10-01').format('YYYY-MM-DD')
  ) {
    return 'dashboard';
  } else {
    const res = await api.user.checkUserRedirectToDashboard();
    if (res.ok) {
      return 'dashboard';
    }
    return 'my-data-page';
  }
}

async function renderRootElement() {
  const root = document.createElement('div');
  const homeRoot = await checkHomeRoot();
  ReactDOM.render(
    <Root store={store} history={browserHistory} homeRoot={homeRoot} />,
    root
  );

  document.body.appendChild(root);
}

function configureSentry() {
  // send error to sentry, https://docs.sentry.io/clients/javascript/integrations/react/
  Raven.config(__SENTRY_DSN__).install();
}

function configureMoment() {
  /* Moment default language is 'en' so need to load 'zh-cn' & 'ja' to make it available */
  moment.locale('zh-cn');
  moment.locale('ja');

  /* Modify the default configurations for 'en', 'zh-cn' & 'ja' */
  const configToBeUpdated = {
    meridiem(hour: number, minute?: number, isLowercase?: boolean) {
      return hour < 12 ? '上午' : '下午';
    },
    longDateFormat: {
      LT: 'A hh:mm',
      LTS: 'A hh:mm:ss',
      L: 'YYYY/MM/DD',
      ll: 'LT, YYYY/MM/DD',
      LL: 'YYYY年MM月DD日',
      lll: 'YYYY/MM/DD LT',
      LLL: 'YYYY年MM月DD日 LT',
      LLLL: 'dddd, MMMM Do YYYY LT',
    },
  };

  moment.updateLocale('zh-cn', configToBeUpdated);
  moment.updateLocale('ja', configToBeUpdated);
  moment.updateLocale('en', {
    longDateFormat: {
      LT: 'hh:mm A',
      LTS: 'hh:mm:ss A',
      L: 'DD/MM/YYYY',
      LL: 'DD/MM/YYYY',
      ll: 'LT, DD/MM/YYYY',
      LLL: 'DD/MM/YYYY LT',
      lll: 'DD/MM/YYYY LT',
      LLLL: 'dddd, MMMM Do YYYY LT',
    },
  });
}

// function configurePiwik() {
//   const state = store.getState();
//   if (state && state.users && state.users.user) {
//     piwikTracker.setUserId(String(state.users.user.id));
//   }
// }

function configureLogRocket() {
  if (window.location.hostname != 'localhost') {
    if (__STAGING__) {
      LogRocketInitWithoutAuth('4bastx/sourcesage');
    } else {
      LogRocketInitWithoutAuth('4bastx/sourcesage-production');
    }
    LogRocket.getSessionURL(sessionURL => {
      Sentry.configureScope(scope => {
        scope.setExtra('sessionURL', sessionURL);
      });
    });
  }
}

function LogRocketInitWithoutAuth(id: string) {
  LogRocket.init(id, {
    network: {
      requestSanitizer: (request: LogRocketRequest) => {
        // if the url contains 'auth'
        if (request.url.toLowerCase().indexOf('auth') !== -1) {
          // ignore the request response pair
          return null;
        }
        // otherwise log the request normally
        return request;
      },
    },
  });
}



// WEBPACK FOOTER //
// ./app/init.tsx